import { Component, OnInit, ViewEncapsulation, AfterViewInit } from "@angular/core";

import { AuthorizationService } from "../../services/authorization.service";

@Component({
  selector: "login-layout",
  templateUrl: "./login-layout.component.html",
  styleUrls: [
    "./login-layout.component.css",
    "../../content/scss/okta-custom.scss"
  ],
  encapsulation: ViewEncapsulation.None
})
export class LoginLayoutComponent implements OnInit, AfterViewInit {
  constructor(
    private authorizationService: AuthorizationService,  
  ) {}

  ngOnInit() {
    this.authorizationService.url = "/";
    // this.route.data.subscribe(
    //   (data: { resources: { [id: string]: Resource } }) => {
    //     this.resourcesService.setGlobalResources(data.resources);
    //   }
    // );
  }

  ngAfterViewInit() {
    try {
      let millis = Date.now() - window['metrics'].startTime;
      window['logWithTime']('Total Time to Show View : ' + millis / 1000);
    } catch (e) {
      
    }
  }
}
